import { styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const ContainerW = styled('div')<{ isListLength: boolean }>`
  width: 100%;
  border-radius: 15px;
  position: relative;
  backgroundcolor: #fbfbfb;

  @media (max-width: 1024px) {
    margin-top: 16px;
    width: 100%;
  }

  @media (max-width: 520px) {
    height: ${({ isListLength }) => (isListLength ? '264px' : '182px')};
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (max-width: 1024px) {
    margin-bottom: 0px;
  }
`;

export const Title = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const EmptyStateTitle = styled(Typography)`
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.p040};
  white-space: break-spaces;
  margin-top: 24px;
`;

export const EmptyStateImage = styled('img')`
  margin-top: 10px;

  @media (max-width: 520px) {
    margin-top: 0;
  }
`;

export const ListContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 8px;
  column-gap: 12px;
  padding-bottom: 16px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    overflow-y: auto;
    max-height: calc(100vh - 540px);
    padding-bottom: 0px;
  }
`;

export const ListItem = styled('div')`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
  padding: 15px 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.info.light};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyStateContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  padding: 16px 16px 40px 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white.main};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const NavLinkW = styled(NavLink)`
  color: ${({ theme }) => theme.palette.info.main};
`;

export const EquipmentListWrapper = styled('div')`
  margin-top: 40px;
  padding: 16px;
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  background-color: ${({ theme }) => theme.palette.white.main};

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;
